const getCssRuleBySelector = (stylesheet, selector) =>
  Object.values(stylesheet.cssRules).find(({ selectorText }) => selectorText === selector);

export default getCssRuleBySelector;
